/**
 * @file error.js
 * @fileoverview Renders the error page.
 * @namespace error
 * @description The Error page.
 * @module common/assets/pages/Page/error
 * @since 3.0.0
 * @version 3.0.0
 */

import { i18n, loading, outputDiv } from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement.js";
import { loadingGif } from "commonAssets/lib/loadingGif.js";

/**
 * Renders the error page.
 *
 * @param {Object} params - The parameters for the error page.
 */
export const errorPage = (params) => {
    console.log("[Error Page] ...");
    const notFound = createElement(
        "div",
        {
            class: "error",
            id: "page-not-found",
        },
        [
            createElement("h3", { class: "fs-1" }, [], `404`),
            createElement("p", {}, [], i18n.getTranslation("error")),
        ]
    );
    outputDiv.appendChild(notFound);
    loadingGif(loading, "hide", 100);
};
